import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_ASSOCIATION } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetUserRelationshipsProps {
  userId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUserRelationships = async (userId: string) =>
  await axiosAuth.get(`${PROPERTY_ASSOCIATION}/users/${userId}/relationships`);

const useGetUserRelationships = ({
  userId,
  queryParams,
}: UseGetUserRelationshipsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user-relationships", userId],
    queryFn: () => getUserRelationships(userId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!userId && (queryParams?.enabled ?? true),
  });
};

export default useGetUserRelationships;
